<template><section><template>
<h3>折叠面板</h3>
<div class="bs-docs-section">
<div class="bs-example">
  <p>
    <input type="checkbox" v-model="checked">
    一次只打开一个
  </p>
  <n3-accordion :one-at-time="checked" @change="change">
    <n3-panel :is-open="true" index="1" @change="change">
      <div slot="header">Panel #1</div>
      <p>...</p>
      <p>...</p>
      <p>...</p>
    </n3-panel>
    <n3-panel header="Panel #2" index="2">
      <p>...</p>
      <p>...</p>
      <p>...</p>
      </n3-panel>
    <n3-panel header="Panel #3" index="3">
      <p>...</p>
      <p>...</p>
      <p>...</p>
    </n3-panel>
    <n3-panel header="Panel #4" index="4">
      <p>...</p>
      <p>...</p>
      <p>...</p>
    </n3-panel>
  </n3-accordion>
</div>
<pre v-pre=""><code v-pre="" class="language-html"><span class="hljs-tag">&lt;<span class="hljs-name">n3-accordion</span> <span class="hljs-attr">:one-at-time</span>=<span class="hljs-string">"checked"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-panel</span> <span class="hljs-attr">:is-open</span>=<span class="hljs-string">"true"</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"1"</span> <span class="hljs-attr">@change</span>=<span class="hljs-string">"change"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">div</span> <span class="hljs-attr">slot</span>=<span class="hljs-string">"header"</span>&gt;</span>Panel #1<span class="hljs-tag">&lt;/<span class="hljs-name">div</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-panel</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-panel</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"Panel #2"</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"2"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;/<span class="hljs-name">n3-panel</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-panel</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"Panel #3"</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"3"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-panel</span>&gt;</span>
  <span class="hljs-tag">&lt;<span class="hljs-name">n3-panel</span> <span class="hljs-attr">header</span>=<span class="hljs-string">"Panel #4"</span> <span class="hljs-attr">index</span>=<span class="hljs-string">"4"</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
    <span class="hljs-tag">&lt;<span class="hljs-name">p</span>&gt;</span>...<span class="hljs-tag">&lt;/<span class="hljs-name">p</span>&gt;</span>
  <span class="hljs-tag">&lt;/<span class="hljs-name">n3-panel</span>&gt;</span>
<span class="hljs-tag">&lt;/<span class="hljs-name">n3-accordion</span>&gt;</span>
</code></pre>
<pre v-pre=""><code v-pre="" class="language-javascript"><span class="hljs-keyword">export</span> <span class="hljs-keyword">default</span> {
  data () {
    <span class="hljs-keyword">return</span> {
      <span class="hljs-attr">checked</span>: <span class="hljs-literal">true</span>
    }
  },
  <span class="hljs-attr">methods</span>: {
    change (show) {
      <span class="hljs-built_in">console</span>.log(show)
    }
  }
}
</code></pre>
<h3>According参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>one-at-time</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>控制当一个面板被打开时，其他面板是否关闭</td>
</tr>
<tr>
<td>effect</td>
<td><code v-pre="">String</code></td>
<td><code v-pre="">collapse</code></td>
<td>切换动画</td>
</tr>
</tbody>
</table>
<h3>According 事件</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>改变时的回调函数,参数为panel的状态数组</td>
<td></td>
</tr>
</tbody>
</table>
<h3>Panel参数</h3>
<table>
<thead>
<tr>
<th>参数名</th>
<th>类型</th>
<th>默认值</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>is-open</td>
<td><code v-pre="">Boolean</code></td>
<td><code v-pre="">false</code></td>
<td>面板打开还是关闭</td>
</tr>
<tr>
<td>header</td>
<td><code v-pre="">String</code></td>
<td></td>
<td>面板头部显示的内容，点击该内容进行面板的打开收缩</td>
</tr>
</tbody>
</table>
<h3>Panel Events</h3>
<table>
<thead>
<tr>
<th>事件名称</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>change</td>
<td>改变时的回调函数,参数为panel的状态</td>
<td></td>
</tr>
</tbody>
</table>
</div>
</template>

</section></template>

<script>
export default {
  data () {
    return {
      checked: true
    }
  },
  methods: {
    change (show) {
      console.log(show)
    }
  }
}
</script>


// WEBPACK FOOTER //
// n3AccordionDocs.md?1fe7bef9